if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();

      this.mainDetailsToggle = this.querySelector('details');
      this.elements = {
        shareButton: this.querySelector('button.share-button__button'),
        shareSummary: this.querySelector('summary'),
        closeButton: this.querySelector('.share-button__close'),
        copyButton: this.querySelector('.share-button__copy'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      };
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share && this.elements.shareButton) {
        if (this.mainDetailsToggle) this.mainDetailsToggle.hidden = true;
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => {
          navigator.share({ url: this.urlToShare, title: document.title }).catch(() => {});
        });
        return;
      }

      if (!this.mainDetailsToggle) return;
      this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
      if (this.elements.copyButton) this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      if (this.elements.closeButton) this.elements.closeButton.addEventListener('click', this.close.bind(this));
    }

    toggleDetails() {
      if (this.mainDetailsToggle.open || !this.elements.successMessage) return;
      this.elements.successMessage.classList.add('hidden');
      this.elements.successMessage.textContent = '';
      if (this.elements.closeButton) this.elements.closeButton.classList.add('hidden');
    }

    copyToClipboard() {
      if (!this.elements.urlInput || !navigator.clipboard) return;
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent =
            window.accessibilityStrings?.shareSuccess || 'Link copied';
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        }
      });
    }

    close() {
      this.mainDetailsToggle.removeAttribute('open');
      if (this.elements.shareSummary) this.elements.shareSummary.focus();
    }

    updateUrl(url) {
      this.urlToShare = url;
      if (this.elements.urlInput) this.elements.urlInput.value = url;
    }
  });
}
